<template>
  <div class="content">
    <div style="height: 100px;display: flex;align-items: center;">
      <el-button plain :icon="Back" style="background-color: transparent;border:0;" @click="goBack">返回列表</el-button>
    </div>
    <div style="background: #ffffff;">
      <div class="jibenxinxi">
        <div class="tupian">
          <img src="https://oss.xuxug.com/static/images/288.jpg" alt="" class="goods_item_img"
            v-if="datainfo.img == ''">
          <img :src="datainfo.img" alt="" class="goods_item_img" v-else>
        </div>
        <div></div>
        <div class="xinxi">
          <div class="goodstitle">{{ datainfo.title }}</div>
          <div
            style="margin-top: 20px;text-align: left;font-size: 1.75rem;font-weight: 700;color: #e53e3e;text-shadow: 0 1px 1px rgba(0, 0, 0, .1);">
            ¥{{ datainfo.shoujia }}
          </div>
        </div>
      </div>
      <el-divider border-style="dashed" />
      <div
        style="position:relative;background: #ffffff;border-radius: 10px;margin-top:0px;overflow: hidden;padding: 0px 20px;">
        <div
          style="text-align: left;margin-left:0px;font-size: 1.125rem;line-height: 1.75rem;display: flex;align-items: center;font-weight: 700;">
          订单信息
        </div>

        <div class="card-title">
          <div style="margin: 10px 0px;">订单号：{{ datainfo.dingdanhao }}</div>
          <div style="margin: 10px 0px;">订单金额：{{ datainfo.zhifu_jine }} 元</div>
          <div style="margin: 10px 0px;">下单时间：{{ datainfo.xiadan_time }}</div>
          <div style="margin: 10px 0px;" v-if="datainfo.show_state == '1'">支付时间：{{ datainfo.zhifu_time }}</div>
        </div>
        <div style="margin-top: 20px;">
          <el-row>
            <el-col :span="6">
              <el-button type="success" v-if="datainfo.show_state == '1'"
                style="width: 100%;height: 3.5rem;font-size: 1rem;border-radius: 8px;font-weight: 600;letter-spacing: .5px;transition: all .3s ease;border: none;position: relative;overflow: hidden;box-shadow: 0 4px 12px #4f76c74d;">已支付</el-button>
              <el-button type="danger" v-else @click="lijizhifu"
                style="width: 100%;height: 3.5rem;font-size: 1rem;border-radius: 8px;font-weight: 600;letter-spacing: .5px;transition: all .3s ease;border: none;position: relative;overflow: hidden;box-shadow: 0 4px 12px #4f76c74d;">立即支付</el-button>
            </el-col>
            <el-col :span="4"></el-col>
            <el-col :span="14">

            </el-col>
          </el-row>

        </div>
        <div style="height: 1rem;"></div>
      </div>
    </div>
  </div>
  <div class="pay-container" v-html="payForm"></div>
</template>

<script>
import { ChatSquare, Back } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
//import { showNotify } from 'vant';
export default {
  data() {
    return {
      userinfo: this.$getLoginInfo(),
      id: "",
      datainfo: "",
      showKefu: false,
      ChatSquare: ChatSquare,
      Back: Back,
      showLogin: false,
      form: {
        shoujihao: '',
        yanzhengma: '',
      },
      counting: false,// 是否正在倒计时
      countDown: 60,// 倒计时秒数
      yanzhengzhuangtai: false,
      timer: null,
      payForm: '',
    }
  },
  created() {
    this.id = this.$route.query.id;

    this.getDataInfo(this.id);
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getDataInfo(id) {
      this.$http.post('/api/apinew/getDingdanDetails', {
        id: id,
      },
        {
          headers: {
            'userinfo': this.userinfo
          }
        })
        .then(response => {

          if (response.data.code == "true") {
            this.datainfo = response.data.data;
            document.title = this.datainfo.title;
          }
        })
        .catch(error => {
          console.error('There was an error!', error); // 处理错误
        });
    },
    lijizhifu() {
      if (this.userinfo == '') {
        this.showLogin = true;
      }
      else {
        this.goToZhifu();
      }
    },
    goToZhifu() {
      this.$http.post('/api/apinew/tijiaoPcZhifuInfo', {
        id: this.datainfo.id,
      },
        {
          headers: {
            'userinfo': this.userinfo
          }
        })
        .then(response => {
          if (response.data.code == "true") {
            this.payForm = response.data.data;
            // 渲染表单后自动提交（支付宝表单自带提交逻辑）
            setTimeout(() => {
              document.getElementById('alipaysubmit')?.submit();
            }, 500);
          }
          else {
            ElMessage({
              type: 'info',
              message: '订单信息获取失败',
            })
          }
        })
        .catch(error => {
          console.error('There was an error!', error); // 处理错误
        });
    },
    fasongyanzhengma() {
      var isPhoneValid = /^1[3-9]\d{9}$/.test(this.form.shoujihao);
      if (!isPhoneValid) {
        ElMessage({
          message: '手机号不正确',
          type: 'warning',
        })
        return;
      }
      this.$http.post('/api/apinew/getYzm', {
        phone: this.form.shoujihao,
        type: "0",
      })
        .then(response => {
          if (response.data.code == "true") {
            ElMessage({
              message: '验证码已发送',
              type: 'success',
            });
            this.yanzhengzhuangtai = true;
            this.counting = true;
            this.countDown = 60;
            this.timer = setInterval(() => {
              this.countDown--;
              if (this.countDown <= 0) {
                // 倒计时结束，清除定时器
                clearInterval(this.timer);
                this.counting = false;
              }
            }, 1000);
          }
        })
        .catch(error => {
          console.error('There was an error!', error); // 处理错误
        });
    },
    tijiaodenglu() {
      if (this.form.shoujihao.length != 11) {
        ElMessage({
          message: '手机号不正确',
          type: 'warning',
        });
        return true;
      }

      if (this.form.yanzhengma.length != 6) {
        ElMessage({
          message: '请输入验证码',
          type: 'warning',
        });
        return;
      }
      this.$http.post('/api/apinew/phone', {
        phone: this.form.shoujihao,
        code: this.form.yanzhengma,
        laiyuan: "",
      })
        .then(response => {

          if (response.data.code == "true") {
            ElMessage({
              message: response.data.message,
              type: 'success',
            });
            this.showLogin = false;
            let userinfo = JSON.stringify(response.data.data);
            //console.log(userinfo);
            localStorage.setItem('userinfo', userinfo);
            this.userinfo = this.$getLoginInfo();
            this.getUserInfo();
          }
          else {
            ElMessage({
              message: response.data.message,
              type: 'warning',
            });
            return;
          }
        })
        .catch(error => {
          console.error('There was an error!', error); // 处理错误
        });
    },
  }
}
</script>

<style scoped>
.content {
  margin: 0 auto;
  max-width: 1150px;
  min-height: 100vh;
}

.jibenxinxi {
  border-radius: 10px;
  padding: 20px;
  display: grid;
  grid-template-columns: auto 10px 1fr;
  background: #ffffff;
}

.goods_item_img {
  width: 200px;
  border-radius: 5px 0 0 0px;
  display: block;
  object-fit: contain;
  border-radius: 10px;
}

.goodstitle {
  background: linear-gradient(90deg, #2d3748, #4a5568);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: -.5px;
  text-shadow: 0 2px 2px rgba(0, 0, 0, .05);
  font-size: 1rem;
  line-height: 2rem;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
}

.haoxinxi {
  margin-top: 20px;
  padding: 10px;
  background: #e5e7eb;
  border-radius: 10px;
}

.card-title {
  text-align: left;
  margin: 10px 0px;
  font-size: 14px;
  margin: 0 0 .75rem;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  transition: color .3s ease;
  color: #2a4365;
}

.shangpinxiangqing {
  margin: 20px;
  text-align: left;
  padding: 0px 0px;
  font-size: 14px;
}

.shangpinxiangqing>>>img {
  max-width: 100%;
  margin: 0 auto;
}

.weixin_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #f8fafc;
  border-bottom: 1px solid #eee;
}

.weixintupian {
  margin: 0 auto;
  width: 180px;
  height: 180px;
  border: 1px solid #eee;
  padding: 5px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 12px #0000000d;
}

.tishiwenzi {
  margin: 20px 20px;
  text-align: left;
  font-size: 12px;
  color: #999;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 8px;
}

.tishiwenzi p {
  height: 25px;
}

.window-content {
  position: fixed;
  right: 50px;
  /* 靠右 */
  bottom: 50px;
  /* 靠下 */
  width: 600px;
  height: 600px;
}
</style>